export default __webpack_public_path__ + "static/media/blogImg1.1aa7ef43.jpg";